import React from "react";

import Placeholder, { Rect } from "components/Placeholder";

type Props = {
  className?: string;
  featured?: boolean;
  showExcerpt?: boolean;
  showImage?: boolean;
};

const ArticleCardPlaceholder = ({
  className,
  featured,
  showExcerpt,
  showImage = true,
  ...others
}: Props) => (
  <div className={className} {...others}>
    {showImage && (
      <div>
        <Placeholder
          width="100%"
          viewBox="0 0 100 56.25"
          preserveAspectRatio="xMinYMin meet"
          className="flex-shrink-0"
        >
          <Rect width="100" height="100" />
        </Placeholder>
      </div>
    )}
    <div className="p-md">
      {!featured && (
        <Placeholder width="100%" height="26" className="mb-sm">
          <Rect rx="12" ry="12" width="100" height="26" />
          <Rect x="106" rx="12" ry="12" width="90" height="26" />
        </Placeholder>
      )}
      <Placeholder width="100%" height={featured ? "54" : "46"}>
        <Rect width="100%" height={featured ? "24" : "20"} />
        <Rect
          y={featured ? "28" : "24"}
          width="75%"
          height={featured ? "24" : "20"}
        />
      </Placeholder>
      <div className={featured ? "mt-xs" : "mt-md"}>
        <Placeholder width="100%" height="46">
          <Rect y="4" width="150" height="20" />
          <Rect y="30" width="100" height="14" />
        </Placeholder>
      </div>
      {showExcerpt && (
        <div className="mt-lg">
          <Placeholder width="100%" height={featured ? "72" : "40"}>
            <Rect y="2" width="100%" height={featured ? "18" : "14"} />
            <Rect
              y={featured ? "26" : "23"}
              width="100%"
              height={featured ? "18" : "14"}
            />
            {featured && (
              <Rect y="50" width="75%" height={featured ? "18" : "14"} />
            )}
          </Placeholder>
        </div>
      )}
    </div>
  </div>
);

export default ArticleCardPlaceholder;
